import React, { FunctionComponent, useState } from "react";
import { IRepertoireStateKeys } from "../../types/IRepertoireStateKeys";
import {
    APPLICABLE_WORKS_KEY,
    ASSING_TO_SEARCH_WORKFLOW_STATE_KEY,
    CUSTOMER_NAME,
    CUSTOMER_REFERENCE,
    DISTRIBUTION_MAINTENANCE_GRIDS_VIEW,
    DISTRIBUTION_SUBJECTS_KEY,
    DISTRIBUTION_SUBJECT_LICENSING_TYPE_STATE_KEY,
    DISTRIBUTION_SUBJECT_MEMBER_TYPE_STATE_KEY,
    DISTRIBUTION_SUBJECT_WORK_TYPE_STATE_KEY,
    EMPTY_STRING_VALUE,
    INVALID_KEYS,
    SET_TYPE_GROUP_KEY,
    REPERTOIRE_PAGE_FORM_ACTION_BUTTON_SIZE_2,
    REPERTOIRE_PAGE_FORM_ACTION_BUTTON_SIZE_3,
    REPERTOIRE_PAGE_FORM_ITEM_SIZE,
    REPERTOIRE_PAGE_FORM_LARGE_BOX_SIZE,
    REPERTOIRE_PAGE_FORM_WIDE_SIZE,
    SEARCH_VIEW_WORKFLOW,
    UPDATE_WORKFLOW_VIEW,
    UPDATE_WORKFLOW_VIEW_STATUS_FIELD_STATE_KEY,
    VALUE_KEY_VALUE_STATE_KEY,
    VENUE_LOOKUP_FIELD_STATE_KEY,
    WORKFLOW_ENTITY_TYPE_STATE_KEY,
    WORK_MAINTENANCE_TERRITORY_SPECIFIC_INFO_VIEW,
    OTHER_KEY,
    WORK_OTHERCONTRIBUTOR_SOURCETYPE_STATE_KEY,
    WORK_OTHERCONTRIBUTOR_SOURCEIP_STATE_KEY,
    WORK_OTHERCONTRIBUTOR_SOURCESOCIETY_STATE_KEY,
    REPERTOIRE_PAGE_FORM_ITEM_SIZE_FOUR_ITEMS_PER_ROW
} from "../../Consts";
import { Dropdown, DropdownMenuItemType, IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { ComboBox, IComboBoxStyles } from "@fluentui/react";
import { IMembersPortalStateKeys } from "../../../membersportal/types/IMembersPortalStateKeys";
import { CEDRO_CUSTOMER_NAME } from "../../../home/Consts";
import { MEMBERS_PORTAL } from "../../../accounts/Consts";

export interface IDropdownDataInputProps {
    label?: string;
    value: any;
    changeData: (
        value: string | string[] | boolean,
        fieldName: IRepertoireStateKeys | IMembersPortalStateKeys,
        index?: number,
        event?: any
    ) => void;
    fieldName: IRepertoireStateKeys | IMembersPortalStateKeys;
    options: {
        code: string;
        description: string;
        extraFields?: object;
    }[];
    allowNull: boolean;
    showDropdownsAsCodes?: boolean;
    readOnly?: boolean;
    isHidden: boolean;
    componentInstance?: string;
    selectedCode?: string;
    index?: number;
    useComboBoxAsMenuWidth?: boolean;
    isMandatory?: boolean;
    key?: string;
    backendSearch?: boolean;
    onBackendSearch?: (value: string, e?: any) => void;
    customer?: string;
    allowFreeInput?: boolean;
    portalType?: string;
    pinnedRegions?: string[];
    withRepertoireHeader?: string;
    withoutRepertoireHeader?: string;
}

export const SizedDropdownDataInput: FunctionComponent<IDropdownDataInputProps> = (props: IDropdownDataInputProps) => {

    if (props.isHidden)
        return null;
    let containerClass: string = "";

    if (props.componentInstance === SEARCH_VIEW_WORKFLOW) {

        if (props.fieldName === WORKFLOW_ENTITY_TYPE_STATE_KEY)
            containerClass = REPERTOIRE_PAGE_FORM_ACTION_BUTTON_SIZE_3;
        else if (props.fieldName === UPDATE_WORKFLOW_VIEW_STATUS_FIELD_STATE_KEY)
            containerClass = REPERTOIRE_PAGE_FORM_ACTION_BUTTON_SIZE_2;
        else if (props.fieldName === ASSING_TO_SEARCH_WORKFLOW_STATE_KEY)
            containerClass = REPERTOIRE_PAGE_FORM_ACTION_BUTTON_SIZE_3;
        else if(props.fieldName === VALUE_KEY_VALUE_STATE_KEY)
            containerClass = "";
        else
            containerClass = REPERTOIRE_PAGE_FORM_ITEM_SIZE;
    }
    else if (props.componentInstance === UPDATE_WORKFLOW_VIEW) {
        containerClass = REPERTOIRE_PAGE_FORM_WIDE_SIZE;
    }
    else if (props.fieldName === VENUE_LOOKUP_FIELD_STATE_KEY) {
        containerClass = REPERTOIRE_PAGE_FORM_WIDE_SIZE;
    }
    else if (props.componentInstance === DISTRIBUTION_SUBJECTS_KEY) {

        if (props.fieldName === DISTRIBUTION_SUBJECT_WORK_TYPE_STATE_KEY)
            containerClass = REPERTOIRE_PAGE_FORM_ACTION_BUTTON_SIZE_3;
        else if (props.fieldName === DISTRIBUTION_SUBJECT_LICENSING_TYPE_STATE_KEY)
            containerClass = REPERTOIRE_PAGE_FORM_ACTION_BUTTON_SIZE_3;
        else if (props.fieldName === DISTRIBUTION_SUBJECT_MEMBER_TYPE_STATE_KEY)
            containerClass = REPERTOIRE_PAGE_FORM_ACTION_BUTTON_SIZE_3;
    }
    else if (props.componentInstance === OTHER_KEY) {
        if (props.fieldName === WORK_OTHERCONTRIBUTOR_SOURCETYPE_STATE_KEY
            ||
            props.fieldName === WORK_OTHERCONTRIBUTOR_SOURCEIP_STATE_KEY
            ||
            props.fieldName === WORK_OTHERCONTRIBUTOR_SOURCESOCIETY_STATE_KEY)
            containerClass = REPERTOIRE_PAGE_FORM_ITEM_SIZE_FOUR_ITEMS_PER_ROW;
    }
    else {
        containerClass = REPERTOIRE_PAGE_FORM_ITEM_SIZE;
    }

    //const containerClass: string = (props.componentInstance && props.componentInstance === UPDATE_WORKFLOW_VIEW) ? EMPTY_STRING_VALUE : REPERTOIRE_PAGE_FORM_ITEM_SIZE
    return <div className={containerClass}>
        <DropdownDataInput {...props} />
    </div>
}

const DropdownDataInput: FunctionComponent<IDropdownDataInputProps> = ({
    options,
    label,
    changeData,
    value,
    fieldName,
    allowNull,
    showDropdownsAsCodes,
    readOnly,
    componentInstance,
    selectedCode,
    index,
    useComboBoxAsMenuWidth,
    isMandatory,
    key,
    backendSearch,
    onBackendSearch,
    customer,
    allowFreeInput,
    portalType,
    pinnedRegions,
    withRepertoireHeader,
    withoutRepertoireHeader
}) => {
    const makeOptionsList = () => {
        var arr: IDropdownOption[] = [];
        if (allowNull) {
            arr.push({ key: -1, text: "", data: "" });
        }

        if (options) {
            var optionGroups: { [key: string]: IDropdownOption[] } = {};
            if (fieldName === "numbers")   options = [...options].sort((a, b) => a.description.localeCompare(b.description.toLowerCase()));

            if (fieldName === "musicArrangement" || fieldName === "lyricAdaptation") {
                options.forEach((opt, i) => {
                    const optElement: IDropdownOption = {
                        key: i,
                        data: opt.code,
                        text: fieldName === "musicArrangement" ? opt.extraFields['ArrangementType'] : opt.extraFields['AdaptationType'],
                        title: showDropdownsAsCodes ? opt.description : null,
                        disabled: opt.extraFields && opt.extraFields['DisabledInDropdown'],
                        isSelected: opt.code === selectedCode
                    };
                    arr.push(optElement);
                });
            } else {
                options.forEach((opt, i) => {
                    let text: string;
                        if (fieldName === "venueLookupType" && !showDropdownsAsCodes && opt.extraFields && opt.extraFields['Region']) {
                            text = `${opt.description} ,${opt.extraFields['Region']}`;
                        } else {
                            text = showDropdownsAsCodes ? opt.code : opt.description;
                        }
                    const optElement: IDropdownOption = {
                        key: i,
                        data: opt.code,
                        text: text,
                        title: showDropdownsAsCodes ? opt.description : null,
                        disabled: opt.extraFields && opt.extraFields['DisabledInDropdown'],
                        isSelected: opt.code === selectedCode,
                        hidden: portalType === MEMBERS_PORTAL && (opt.extraFields?.['DisplayOnPortal'] === false || opt.extraFields?.['IsDisplayedInPortal'] === false)

                    };
                    if (opt.extraFields && 'Type' in opt.extraFields && opt.extraFields['Type'] !== undefined) {
                        if (opt.extraFields['Type'].toString() in optionGroups) {
                            if (['ISRC', 'ISWC'].includes(opt.code))
                                optionGroups[opt.extraFields['Type'].toString()].unshift(optElement);
                            else
                                optionGroups[opt.extraFields['Type'].toString()].push(optElement);
                        } else {
                            optionGroups[opt.extraFields['Type'].toString()] = [optElement];
                        }
                    } else {
                        arr.push(optElement);
                    }
                });
            }

            for (const group in optionGroups) {
                const groupItem = { key: `Group-${group}`, text: group, title: group, itemType: DropdownMenuItemType.Header };
                if (group === 'Other') {
                    arr.push(groupItem, ...optionGroups[group]);
                } else {
                    arr.unshift(groupItem, ...optionGroups[group]);
                }
            }
        }
        
        return arr;
    };
    const showCodesClassName: string = showDropdownsAsCodes ? ' showAsCode ' : EMPTY_STRING_VALUE
    const componentClassName: string = getComponentClassName(componentInstance, fieldName);

    function getComponentClassName(componentInstance: string, fieldName: string): string {
        if (
            componentInstance === WORK_MAINTENANCE_TERRITORY_SPECIFIC_INFO_VIEW
            &&
            fieldName === SET_TYPE_GROUP_KEY)
            return ' pointerEnable ';

        if (
            componentInstance === OTHER_KEY
            &&
            (
                fieldName === WORK_OTHERCONTRIBUTOR_SOURCETYPE_STATE_KEY
                ||
                fieldName === WORK_OTHERCONTRIBUTOR_SOURCEIP_STATE_KEY
                ||
                fieldName === WORK_OTHERCONTRIBUTOR_SOURCESOCIETY_STATE_KEY
            ))
            return ' otherContributorFilters ';

        return EMPTY_STRING_VALUE;
    }

    const isPinned = (opt: IDropdownOption) =>
        !!pinnedRegions && !!opt.data && pinnedRegions.indexOf(opt.data as string) > -1;


    const insertRegionHeaders = (opts: IDropdownOption[]): IDropdownOption[] => {
        const result: IDropdownOption[] = [];
        let withAdded = false;
        let withoutAdded = false;

        opts.forEach(opt => {
            if (opt.key === -1) { result.push(opt); return; }

            if (isPinned(opt)) {
                if (!withAdded) {
                    result.push({ key: 'hdr-with', text: withRepertoireHeader, itemType: DropdownMenuItemType.Header });
                    withAdded = true;
                }
            } else if (!withoutAdded) {
                result.push({ key: 'hdr-without', text: withoutRepertoireHeader, itemType: DropdownMenuItemType.Header });
                withoutAdded = true;
            }
            result.push(opt);
        });

        return result;
    };
    
    const sortedOptions = makeOptionsList().sort((a, b) => {
        if(fieldName === "memberStatementViewStatementsFrom" || fieldName === "numbers") {return 0}

        if (pinnedRegions && pinnedRegions.length > 0) {
            if (a.key === -1) return -1;          
            if (b.key === -1) return 1;          
            const aPinned = isPinned(a);
            const bPinned = isPinned(b);
            if (aPinned !== bPinned) return aPinned ? -1 : 1;
            return (a.text || '').localeCompare(b.text || '');
        }


        if (fieldName !== 'packageShareSet') {
            if ((a.text && a.text != 'All') && (b.text && b.text != 'All')) {
                return a.text.localeCompare(b.text);
            }
            return 0;
        } else {
            if (a.text === "Repertoire" && b.text !== "Repertoire") return -1;
            if (b.text === "Repertoire" && a.text !== "Repertoire") return 1;
            return a.text.localeCompare(b.text);
        }

    });

    const optionsFinal = (pinnedRegions && pinnedRegions.length > 0)
    ? insertRegionHeaders(sortedOptions)
    : sortedOptions;

    const displayValue: string = !showDropdownsAsCodes ?
        (optionsFinal !== undefined ?
            (value && optionsFinal.find(opt => opt.data == value) ?
                optionsFinal.find(opt => opt.data == value).text : value || '')
            : value || ''
        ) : value || '';

    const selectedValue = !showDropdownsAsCodes ?
        optionsFinal.find((option) => option.text === displayValue) :
        optionsFinal.find((option) => option.data === displayValue);


  const onKeyDownAction = (key: string) => {
      if (backendSearch) onBackendSearch(key);
    } 
    
    const onChangesHanle = ( item) => { 
        if (componentInstance === CUSTOMER_NAME) {
            changeData(item, fieldName, index)
        } else {
            changeData(item.data, fieldName, index)
        }
    }
    const renderOption = (option?: IDropdownOption, defaultRender?: (o?: IDropdownOption) => JSX.Element): JSX.Element => {
        if (!isPinned(option)) return defaultRender ? defaultRender(option) : <>{option?.text}</>;
        return <b>{option?.text}</b>;
    };
    
    return (
        <div key={key} className={customer === CEDRO_CUSTOMER_NAME ? "dropdownDataInput extraWidth" : "dropdownDataInput"}>
            <ComboBox
                label={label ? label + ':' : undefined}
                options={optionsFinal}
                onChange={(_event, item) => { onChangesHanle( item); }}
                onInputValueChange={(val) => { onKeyDownAction(val) }}
                useComboBoxAsMenuWidth={useComboBoxAsMenuWidth === false ? false : true}
                calloutProps={{ calloutMaxHeight: 270 }}
                placeholder={displayValue}
                selectedKey={selectedValue ? selectedValue.key : null}
                className={showCodesClassName.concat(componentClassName,
                    isMandatory ? " required " : "",
                    readOnly ? " disabledItem " : "")}
                disabled={readOnly}
                allowFreeInput={allowFreeInput === false ? allowFreeInput : true}
                autoComplete={!backendSearch  ? "on" : "off"}
                data-testid={fieldName + "-combo-box"}
                onRenderOption={pinnedRegions?.length ? renderOption : undefined}
            />
        </div>
    );
};

export default DropdownDataInput;
